export enum NewsletterStatus {
  Subscribed = 'subscribed',
  Unsubscribed = 'unsubscribed',
  Cleaned = 'cleaned',
  Pending = 'pending',
  None = 'none',
}
